export const BaseConfig = {
  apiHostGateway: 'https://api.sandbox.finalcad.cloud',
  apiHostGatewayGlobal: 'https://api.global.sandbox.finalcad.cloud/',
  overridesMediaServiceUrl: false, // Don't ever enable this in production
  clarityProjectId: 'sb8wrxq21e',
  grpcGateway: 'https://realtime-service-pusher.priv.eu.sandbox.finalcad.cloud',
  apiRegistrationToken: '$2y$10$u1zVgUEarYkXfAVaILbg/O1xy.7oJJg5MnkMjpta3youaMO2LMvGq',
  pdfTronLicenseKey:
    'demo:1775221906812:635c962f03000000000972682f0c928c2509cf6fac13eb7a20d9764301',
  firebaseConfig: {
    apiKey: 'AIzaSyDQQs8qA71W7cD6jTkkr8xuMoBjwacpm6U',
    authDomain: 'finalcad-one-beta.firebaseapp.com',
    databaseURL: 'https://finalcad-one-beta.firebaseio.com',
    projectId: 'finalcad-one-beta',
    storageBucket: 'finalcad-one-beta.appspot.com',
    messagingSenderId: '896568218983',
    appId: '1:896568218983:web:a00a35a6e5f0e9c2e18bc2', // Mapped to Firebase Finalcad One Web Dev
    measurementId: 'G-26CZ49D2BT',
  },
  stripeCheckoutKey:
    'pk_test_51ILQ3mLfL2ThMUp8pTzJVg40sM7RsD7uiDDNlc0N5KVrP9VGD6PH4IYUFSpUue6OMlH6sS1TvXgtkOQVXVZJs8fw00zmqqylhD',
  sentry: {
    environment: 'localhost',
    dsn: 'https://b2eacd9ee816459db8255b0242269e03@o1003935.ingest.sentry.io/5964925',
  },
  googleMapsApiKey: 'AIzaSyAEmhLO21A_KSfPNbh6QMQMpfco7TOkluQ',
  gleap: {
    appToken: 'JLKq5vEGs1w9TKZPRl15SYQGJpYtTi1N',
  },
  auth0: {
    domain: 'finalcad-one-preview.eu.auth0.com',
    clientId: 'MHRK4pVMLv8ylDqTagN2FBWMKcwkYr9Y',
    audience: 'https://auth0.api.preview.finalcad.com',
    tokenUrl: `https://finalcad-one-preview.eu.auth0.com/oauth/token`,
    passwordRealmGrantType: 'http://auth0.com/oauth/grant-type/password-realm',
    refreshTokenGrantType: 'refresh_token',
    realm: 'Username-Password-Authentication',
    scope: 'openid profile email offline_access',
  },
  kolimmo: {
    url: 'https://app.staging.kolimmo.com/pro/sites',
  },
};
